import {
	IFormErrors,
	trackFormValidationErrors,
} from '../../../../../../shared/analytics/form/trackFormValidationErrors';
import {
	EVENT_ACTION_PARKING_PERSONAL_DETAILS_VALIDATION_ERROR,
	EVENT_CATEGORY_PARKING_PERSONAL_DETAILS,
} from '../../../../../../shared/analytics';
import { IDetailsFormData } from '../../../details/types/IDetailsFormData';

export function trackDetailsValidationErrors(
	errors: IFormErrors<IDetailsFormData>,
) {
	trackFormValidationErrors({
		category: EVENT_CATEGORY_PARKING_PERSONAL_DETAILS,
		action: EVENT_ACTION_PARKING_PERSONAL_DETAILS_VALIDATION_ERROR,
		errors,
	});
}
